import React from "react";
import "./style.scss";
import SelectVariant from "../../../components/Seggregation/SelectVariant";
const SelectVariantPage = () => {
  return (
    <div className="select_variant_page_wrapper">
      <SelectVariant />
    </div>
  );
};

export default SelectVariantPage;
